export default "__VITE_ASSET__CzR_aec1__"